<div class="images">
    <app-goal></app-goal> 
    <router-outlet></router-outlet>
</div>
